export const FIELD_TYPES = {
	DATE: 1,
	NUMBER: 2,
	CHECKBOX: 3,
	TEXT: 4,
	SLIDER: 5,
	DATETIME: 6,
	MEMO: 7,
	TIME: 8,
	RESOURCE_TYPE: 9,
	LOCATION_DRILLDOWN: 10,
	LIST: 11,
	CATEGORIES: 12,
	IMAGE: 13,
	FILE: 14,
	IMAGES: 15,
	FILES: 16,
	BITWISE: 17,
	PASSWORD: 18,
	SINGLE_LOCATION: 19,
	USERS: 20,
	LABEL: 21,
	PUBLIC_USERS: 22,
};

export const LOCATION_TYPES = {
	LOCATION: 1,
	GROUP: 2,
};

export const ATTENDEE_TYPE = {
	HOST: 1,
	REQUIRED: 2,
	OPTIONAL: 3,
};

export const ATTENDEE_RESPONSE_TYPE = {
	NONE: 0,
	ACCEPTED: 1,
	DECLINED: 2,
	PROPOSAL: 3,
	DELETED: 4,
	CONFIRMED: 5,
};

export const RECURRENCE_TYPES = {
	NONE: 0,
	DAILY: 1,
	WEEKLY: 2,
	MONTHLY: 3,
	YEARLY: 4,
	OCCURRENCE: 5,
};

export const DATE_ZERO_ISO_STRING = '0001-01-01T00:00:00.000Z';

export const COOKIE_DURATION = {
	NONE: 0,
	SHORT: 1,
	LONG: 2,
};

export const LOCATION_SELECTION = {
	FULL: 'full',
	PARTIAL: 'partial',
	NONE: 'none',
};
